var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/apis/mtop/index.ts
import UA2 from "@ali/tbm-ua";

// src/apis/mtop/mtop.themis.tb.ts
import { callThemis } from "@ali/abridge";

// src/apis/mtop/mtop.nebula.ap.ts
import { callNebula } from "@ali/abridge";
import UA from "@ali/tbm-ua";
var RESPONSE_TYPE = {
  ERROR: -1,
  SUCCESS: 0,
  TOKEN_EXPIRED: 1,
  SESSION_EXPIRED: 2
};
var formatPayload = (_a) => {
  var _b = _a, { api, v, ecode, data, ttid, method } = _b, others = __objRest(_b, ["api", "v", "ecode", "data", "ttid", "method"]);
  const __payload = __spreadValues({
    api,
    v,
    data,
    needEcodeSign: ecode === 1,
    needWua: true,
    post: (method == null ? void 0 : method.toUpperCase()) === "POST" ? 1 : 0,
    isNeedWua: true
  }, others);
  __payload.data.ecode = ecode;
  ttid && (__payload.ttid = ttid);
  return __payload;
};
var parseRetType = (ret = [""]) => {
  if (ret[0].match(/SUCCESS/)) {
    return RESPONSE_TYPE.SUCCESS;
  } else if (ret[0].match(/TOKEN_EMPTY|TOKEN_EXPIRED/)) {
    return RESPONSE_TYPE.TOKEN_EXPIRED;
  } else if (ret[0].match(/SESSION_EXPIRED|SID_INVALID|AUTH_REJECT|NEED_LOGIN/)) {
    return RESPONSE_TYPE.SESSION_EXPIRED;
  }
  return RESPONSE_TYPE.ERROR;
};
var formatResponse = (options, { api, v, data, ret, error, errorMessage, __eagleeye_traceid__ }) => {
  return {
    api: api || options.api,
    v: v || options.v,
    data: data || {},
    retType: parseRetType(ret),
    ret: ret || [`${error}::${errorMessage}`],
    traceId: __eagleeye_traceid__ || ""
  };
};
var mtopByTaoPiaoPiao = (options) => callNebula("mtopRequest", formatPayload(options), (res) => {
  return formatResponse(options, res);
});
var formatPayloadAnt = (_a) => {
  var _b = _a, {
    api,
    v,
    ecode,
    data,
    ttid,
    method,
    valueType
  } = _b, others = __objRest(_b, [
    "api",
    "v",
    "ecode",
    "data",
    "ttid",
    "method",
    "valueType"
  ]);
  const usePost = (method == null ? void 0 : method.toUpperCase()) === "POST";
  let needEcodeSign = ecode === 1;
  if (UA.isYKApp && UA.isIOS) {
    needEcodeSign = 0;
  }
  const payload = __spreadValues({
    data,
    ttid,
    apiName: api,
    apiVersion: v,
    needEcodeSign,
    needWua: true,
    isNeedWua: true,
    usePost
  }, others);
  const __payload = valueType === "original" ? __spreadProps(__spreadValues({}, payload), { type: "originaljson" }) : payload;
  __payload.data.ecode = ecode;
  ttid && (__payload.ttid = ttid);
  return __payload;
};
var mtopByAlipayJSBridge = (options) => callNebula("mtop", formatPayloadAnt(options), (res) => {
  return formatResponse(options, res);
});
var mtop = (options) => {
  if (UA.isDY) {
    return mtopByTaoPiaoPiao(options);
  }
  return mtopByAlipayJSBridge(options);
};

// src/apis/mtop/mtop.themis.tb.ts
var mtopByThemis = (options) => {
  return new Promise((resolve, reject) => {
    const mapParams = Object.assign({}, options, {
      needLogin: options.ecode === 1,
      responseType: options.valueType === "original" ? "ORIGINAL_JSON" : "JSON",
      onReceiveData: (result) => {
        resolve(result);
      },
      onFailure: (errorInfo) => {
        reject(errorInfo);
      }
    });
    console.log(
      "\u8001\u9E7F\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u6D4B\u8BD5MTOP\u53C2\u6570------themis\u5BB9\u5668=======>",
      JSON.stringify(mapParams)
    );
    callThemis("MTOP.requestData", mapParams, (res) => ({
      api: res.api,
      v: res.v,
      data: res.data || {},
      retType: parseRetType(res.ret),
      ret: res.ret
    }));
  });
};
var mtop2 = (options) => {
  return mtopByThemis(options);
};

// src/apis/mtop/mtop.windvane.ts
import { windVaneLoader } from "@ali/abridge";

// src/utils/h5MtopSetup.ts
import domain from "@ali/lib-mtop-middleware-tbm-domain";
import emoji from "@ali/lib-mtop-middleware-emoji";
function registerDYMiddlewaresIfNotExist() {
  var _a, _b;
  if (!((_a = window == null ? void 0 : window.lib) == null ? void 0 : _a.mtop)) {
    throw new Error("please config @ali/lib-mtop");
  }
  if (((_b = window.lib.mtop.middlewares) == null ? void 0 : _b.findIndex(
    (fn) => fn.__mtop_middleware_name__ === "tbm-domain"
  )) === -1) {
    window.lib.mtop.middlewares.push(domain);
    window.lib.mtop.middlewares.push(emoji);
  }
}

// src/apis/mtop/mtop.windvane.ts
var formatPayloadTB = (_a) => {
  var _b = _a, { api, v, ecode, data, isSec, method } = _b, others = __objRest(_b, ["api", "v", "ecode", "data", "isSec", "method"]);
  return __spreadValues({
    api,
    v,
    data,
    ecode: ecode || 0,
    isSec: isSec || 0,
    type: (method == null ? void 0 : method.toUpperCase()) || "GET"
  }, others);
};
var mtop3 = (options) => {
  return new Promise((resolve, reject) => {
    windVaneLoader(() => {
      registerDYMiddlewaresIfNotExist();
      console.log(
        "\u8001\u9E7F\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u{1F98C}\u6D4B\u8BD5MTOP\u53C2\u6570-----windvane\u5BB9\u5668=======>",
        JSON.stringify(formatPayloadTB(options))
      );
      window.lib.mtop.request(formatPayloadTB(options)).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  });
};

// src/apis/mtop/mtop.h5.ts
var formatPayload2 = (_a) => {
  var _b = _a, { api, v, ecode, data, method, isSec } = _b, others = __objRest(_b, ["api", "v", "ecode", "data", "method", "isSec"]);
  return __spreadValues({
    api,
    v,
    data,
    ecode: ecode || 0,
    isSec: isSec || 0,
    H5Request: true,
    type: (method == null ? void 0 : method.toUpperCase()) || "GET"
  }, others);
};
var mtop4 = (options) => {
  return new Promise((resolve, reject) => {
    registerDYMiddlewaresIfNotExist();
    window.lib.mtop.request(formatPayload2(options)).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/apis/mtop/index.ts
import { notSupportForPromise as notSupport } from "@ali/abridge";
var mtop5 = (...args) => {
  let options = args[0];
  let callback = args[1];
  if (callback === void 0 && typeof options === "function") {
    callback = options;
    options = void 0;
  }
  let _mtop;
  if (UA2.isThemis && UA2.isDM) {
    _mtop = mtop2;
  } else if (UA2.isThemis && UA2.isDY) {
    _mtop = mtop2;
  } else if (UA2.isThemis && UA2.isTB) {
    _mtop = mtop2;
  } else if (UA2.isYKApp) {
    _mtop = mtop;
  } else if (UA2.isNebula && UA2.isAP) {
    _mtop = mtop;
  } else if (UA2.isWindVane) {
    _mtop = mtop3;
  } else {
    _mtop = mtop4;
  }
  if (!_mtop) {
    if (mtop4) {
      _mtop = mtop4;
    } else {
      _mtop = notSupport;
    }
  }
  if (typeof _mtop["changeChannel"] === "function" && typeof options !== "function" && options.useH5 === void 0) {
    _mtop["changeChannel"](options);
  }
  if ((options == null ? void 0 : options.useH5) && mtop4) {
    _mtop = mtop4;
  }
  if (callback && typeof callback === "function") {
    return new Promise((resolve, reject) => {
      let apiPromise = options ? _mtop(options) : _mtop();
      apiPromise && apiPromise.then && apiPromise.then(
        (res) => {
          callback == null ? void 0 : callback(res);
          return resolve(res);
        },
        (error) => {
          callback == null ? void 0 : callback(error);
          return reject(error);
        }
      ).catch(() => {
        callback == null ? void 0 : callback({
          message: "\u8C03\u7528\u5931\u8D25~"
        });
      });
    });
  }
  return _mtop(options, callback);
};
export {
  mtop5 as mtop
};
